module.exports = __webpack_public_path__ + "img/tv.67ac70d9.svg";